import { useContext } from 'react'

import { AppContext } from 'providers/context/App'
import { triggerConfirmationPageEvent } from 'services/Analytics'
import { CONFIRMATION_GA4_EVENTS } from 'utils/constants/Enums'
import { BLVD_LOGIN_LINK } from 'utils/constants/Helpers'

export const ManageAppointmentButton = () => {
  const { appMasterData } = useContext(AppContext)

  const openInNewTab = () => {
    const userId = appMasterData.userInfo.boulevard_id
    triggerConfirmationPageEvent(
      CONFIRMATION_GA4_EVENTS.CLICK_MANAGE_APPOINTMENTS,
      userId
    )

    const newWindow = window.open(
      BLVD_LOGIN_LINK,
      '_blank',
      'noopener, noreferrer'
    )
    if (newWindow) newWindow.opener = null
  }

  return (
    <span id="manage-appointments" onClick={openInNewTab} role="none">
      Manage Appointments
    </span>
  )
}
